import { AxiosError } from 'axios'
import { Action, Entity, HttpStatus } from './types/common.enum'

interface IBaseResponse {
  msg: string
  status?: 'error' | 'success'
  action?: Action
}

export interface IErrorResponse extends IBaseResponse {
  info?: string
  [key: string]: any
}

const mappingErrorActionToMessage = (action: Action) =>{
  switch(action){
    case Action.ADD:
      return 'created'
    case Action.DELETE:
      return 'deleted'
    case Action.EDIT:
      return 'updated'
    case Action.PUBLISH:
      return 'published'
    case Action.GET_DETAIL:
      return 'fetched'
    default:
      return ''
  }
}

export const getHttpErrorResponse = ({
  error,
  action,
  entity,
  customError
}: {
  error: AxiosError
  entity?: Entity
  action: Action
  customError?: IErrorResponse
}): IErrorResponse => {
  if (error.response) {
    const { status, statusText, data: errorData } = error.response
    const baseError: IErrorResponse = {
      status: 'error',
      action,
      msg: '',
      info: errorData?.error?.moreInfo || statusText
    }

    switch (status) {
      case HttpStatus.NOT_FOUND:
        baseError.msg = `${entity} not found`
        break;
      case HttpStatus.BAD_REQUEST:
      case HttpStatus.INTERNAL_SERVER_ERROR:
      default:
        baseError.msg = `${entity} is NOT ${mappingErrorActionToMessage(action)} successfully`
    }

    return {...baseError, ...(customError ? customError : {})}
  }
  return {
    msg: 'Unknown error',
    status: 'error'
  }
}

export function isAxiosError<T>(error: unknown): error is AxiosError<T> {
  return (error as AxiosError)?.isAxiosError === true
}